var React = require('react');

function IcThumbUpActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 7.833L11 3.5a3 3 0 013 3V9h4.78a1 1 0 01.98 1.196l-1.117 5.588A4 4 0 0114.721 19H9V7.833zM7 19v-9H4v9h3z","fill":"currentColor"}));
}

IcThumbUpActive.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = IcThumbUpActive;

IcThumbUpActive.default = IcThumbUpActive;
